import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import styles from './MainMenu.module.scss';

const MainMenu = () => {
  const [sideBarOpen, setSideBarOpen] = useState(false);

  return (
    <div className={styles.MainMenu} data-testid="MainMenu">
      <div className={`${styles.sidebar} ${sideBarOpen ? styles.open : styles.closed}`}>
        <div className={styles.content}>
          <NavLink to="/" onClick={() => setSideBarOpen(false)}>
            Home
          </NavLink>
          <NavLink to="/ford-fulkerson" onClick={() => setSideBarOpen(false)}>
            Ford-Fulkerson
          </NavLink>
          <NavLink to="/edmonds-karp" onClick={() => setSideBarOpen(false)}>
            Edmonds-Karp
          </NavLink>
          <NavLink to="/dinic" onClick={() => setSideBarOpen(false)}>
            Dinic
          </NavLink>
          <NavLink to="/goldberg-tarjan" onClick={() => setSideBarOpen(false)}>
            Goldberg Tarjan
          </NavLink>
          <NavLink to="/tests" onClick={() => setSideBarOpen(false)}>
            Tests
          </NavLink>
        </div>
        <button type="button" onClick={() => setSideBarOpen((old) => !old)}>
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default MainMenu;
